import script from "./ButtonCodigoDescuento.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCodigoDescuento.vue?vue&type=script&setup=true&lang=js"

import "./ButtonCodigoDescuento.vue?vue&type=style&index=0&id=7d818e5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d818e5c"]])

export default __exports__